import { memberGQLFields } from '../network/index.js';
import { moderationItemEntityGQLFields, } from './moderationItemEntity.fields.js';
import { moderationItemReporterGQLFields, } from './moderationItemReporter.fields.js';
const BASIC_MODERATION_ITEM_FIELDS = {
    entity: 'basic',
    moderator: 'basic',
    reporters: {
        fields: 'basic',
        variables: { limit: 10 },
    },
};
const ALL_MODERATION_ITEM_FIELDS = {
    entity: 'all',
    moderator: 'all',
    reporters: {
        fields: 'all',
        variables: { limit: 10 },
    },
};
export const moderationItemGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_MODERATION_ITEM_FIELDS;
    if (fields === 'all')
        fields = ALL_MODERATION_ITEM_FIELDS;
    return `
    createdAt
    description
    flaggedBy
    id
    spaceId
    status
    updatedAt
    ${fields.entity
        ? `
      entity {
        ${moderationItemEntityGQLFields(fields.entity)}
      }
    `
        : ``}
    ${fields.moderator
        ? `
      moderator {
        ${memberGQLFields(fields.moderator)}
      }
    `
        : ``}
    ${fields.reporters
        ? `
      reporters(limit: ${fields.reporters.variables.limit}) {
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
        nodes {
          ${moderationItemReporterGQLFields(fields.reporters.fields)}
        }
        edges {
          cursor
          node {
            ${moderationItemReporterGQLFields(fields.reporters.fields)}
          }
        }
      }
    `
        : ``}
  `;
};
